module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M31.83 29.445c-1.681-5.49-6.303-9.699-11.727-9.699h-.059v-.78a6.995 6.995 0 0 0 2.904-5.347h.67c1.409 0 2.553-1.021 2.553-2.43s-1.144-2.43-2.553-2.43c2.234-4.712-1.532-7.391-1.532-7.391-2.553-2.042-6.068-1.773-7.804.688-.895 1.268-.876 1.595-.876 1.595C9.321 1.939 7.152 6.598 8.3 8.757c-1.409 0-2.553 1.021-2.553 2.43s1.144 2.43 2.553 2.43h.67a6.996 6.996 0 0 0 2.904 5.349v.78h-.059c-5.425 0-10.046 4.209-11.727 9.699C-.292 30.681.623 32 1.916 32h28.091c1.291 0 2.204-1.319 1.824-2.555z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/user-4.js
// module id = 1491
// module chunks = 14